<template>
    <div class="containerInner">
        <Breadcrumb :breadcrumbs="breadcrumbs" />
        <div class="productListHeader">
            <div class="headerLeftMenu">
                <span>表示条件</span>
                <span>
                    <input class="searchInputText" type="text" placeholder="商品名 / 商品コード" v-model="searchKeyword"
                        @keydown="enterSearch">
                </span>
                <span>
                    <a class="btn searchBtn" @click="searchProduct">検索</a>
                </span>
                <span>
                    <input id="unregistered" type="checkbox" @change="unregisteredAdset" v-model="isChecked">
                    <label class="unregisteredCheckBox" for="unregistered">広告未登録のみ</label>
                </span>
            </div>
            <div class="headerRightMenu">
                <span>
                    <a class="btn addBtn" @click="showExcludeRanking">ランキング除外設定</a>
                </span>
            </div>
        </div>
        <ul class="productList">
            <li class="productInfo" v-for="(product, i) in products" :key="i">
                <div class="productInfoLeft">
                    <p class="productName">{{ product.productName }}</p>
                    <p class="productNo">
                        <span>商品番号 : </span>
                        <span>{{ product.productId }}</span>
                    </p>
                    <div class="productAdset">
                        <span>広告名 : </span>
                        <span v-if="product.linkedAds == undefined">
                            広告が登録されていません。
                        </span>
                        <span v-else class="registeredAds">
                            <table>
                                <tr v-for="(adMedia, j) in Object.keys(product.linkedAds)" :key="j">
                                    <td class="registeredByAdMediaAd">{{ adMedia }} :</td>
                                    <td class="registeredByAdMediaAd">
                                        <span v-for="(adName, k, adsetIndex) in product.linkedAds[adMedia]" :key="k">
                                            {{ adName }}
                                            <span
                                                v-if="adsetIndex != Object.keys(product.linkedAds[adMedia]).length - 1">,</span>
                                        </span>
                                    </td>
                                </tr>
                            </table>
                        </span>
                    </div>
                    <div class="productExcluded">
                        <span v-if="excludedProducts.includes(product.productId)">ランキング除外</span>
                    </div>
                </div>
                <div class="productInfoRight">
                    <p class="btn editBtn"
                        @click="showControlProduct('InputPrCost', product.productId, product.productName)">PR費入力</p>
                    <p class="btn editBtn"
                        @click="showControlProduct('LinkProductAndAds', product.productId, product.productName)">広告登録
                    </p>
                </div>
            </li>
        </ul>
        <div class="productListFooter">
            <paginate :page-count="getPageCount" :click-handler="clickCallback" :force-page="currentPage"
                :prev-text="'←'" :next-text="'→'" :container-class="'pagination'" :page-class="'page-item'"
                style="display: flex;"></paginate>
        </div>
        <div class="loadingWindow" v-show="this.$store.state.loading">
            <div class="loadingWindowInner">
                <p>{{ this.statusMessage }}</p>
                <vue-loaders name="ball-spin-fade-loader" color="#02AD90" scale="1"></vue-loaders>
            </div>
        </div>
        <modal name="InputPrCost" :draggable="false" :resizable="false" width="80%" height="900px"
            @closed="modalClosed(modalName)">
            <InputPrCost @modalClosed="modalClosed('InputPrCost')" :productId=this.clickProductNo
                :productName=this.clickProductName />
        </modal>
        <modal name="LinkProductAndAds" :draggable="false" :resizable="false" width="90%" height="900px"
            @closed="modalClosed(modalName)">
            <LinkProductAndAds @modalClosed="modalClosed('LinkProductAndAds')" :clickProductNo=this.clickProductNo
                @updateProducts="updateProducts" />
        </modal>
        <modal name="excludeRanking" :draggable="false" :resizable="false" width="85%" height="80%">
            <ExcludeRanking modal-type="roasProduct" @modalClosed="excludeRankingModalClosed" />
        </modal>
    </div>
</template>

<script>
import Breadcrumb from '../components/Breadcrumb.vue'
import LinkProductAndAds from './LinkProductAndAds.vue'
import InputPrCost from './InputPrCost.vue'
import ExcludeRanking from './ExcludeRanking.vue'

export default {
    components: {
        Breadcrumb,
        LinkProductAndAds,
        InputPrCost,
        ExcludeRanking
    },
    data() {
        return {
            isSearchedProduct: false,
            getPageCount: 0,
            clickProductNo: "",
            clickProductName: "",
            currentPage: 1,
            isChecked: false,
            modalName: "",
            perPage: 10,
            searchKeyword: "",
            statusMessage: "",
            products: [],
            initialProducts: [],
            resultProducts: [],
            excludedProducts: [],
            breadcrumbs: [{
                name: 'ホーム',
                path: '/Home'
            },
            {
                name: '商品･広告登録',
                path: '/product_ad_register',
            }]
        }
    },
    mounted: function () {
        this.$store.dispatch("loading", true);
        this.axios.get("/api/linkedProductAndAds?page=" + this.currentPage)
            .then((res) => {
                this.products = res.data.products;
                this.getPageCount = Number(res.data.last_page);
                this.$store.dispatch("loading", false);
            }).catch(() => {
            })
        this.fetchProductSettings();
    },
    methods: {
        clickCallback: function (pageNum) {
            this.currentPage = Number(pageNum);
            const searchWordParam = this.isSearchedProduct ? this.searchKeyword : '';
            this.axios.get("/api/linkedProductAndAds?page=" + this.currentPage, { params: { searchWords: searchWordParam } })
                .then((res) => {
                    this.products = res.data.products;
                    this.$store.dispatch("loading", false);
                }).catch(() => {
                })
        },
        modalClosed(modalName) {
            this.$store.dispatch("loading", false)
            this.$store.dispatch("successful", false)
            this.modalShow = false
            this.$modal.hide(modalName)
        },
        showControlProduct(modalName, productNo, productName) {
            this.clickProductNo = productNo
            this.clickProductName = productName
            this.modalShow = true
            this.$modal.show(modalName)
        },
        showExcludeRanking() {
            this.modalShow = true
            this.$modal.show('excludeRanking')
        },
        excludeRankingModalClosed() {
            this.fetchProductSettings();
            this.modalShow = false
            this.$modal.hide('excludeRanking')
        },
        searchProduct: function () {
            this.currentPage = 1;
            this.axios.get("/api/linkedProductAndAds?page=1", { params: { searchWords: this.searchKeyword } })
                .then((res) => {
                    this.isSearchedProduct = (this.searchKeyword === '') ? false : true;
                    this.products = res.data.products;
                    this.getPageCount = Number(res.data.last_page);
                    this.resultProducts = this.products
                    if (this.isChecked) {
                        this.products = this.products.filter(function (product) {
                            return product["linkedAds"] == undefined
                        })
                    }
                }).catch(() => {
                })
        },
        enterSearch: function (e) {
            if (e.keyCode == 13) {
                this.searchProduct();
            }
        },
        unregisteredAdset: function () {
            this.currentPage = 1
            if (this.isChecked) {
                this.initialProducts = this.products
                this.products = this.products.filter(function (product) {
                    return product["linkedAds"] == undefined
                })
            } else {
                if (this.resultProducts.length == 0) {
                    this.products = this.initialProducts
                } else {
                    this.products = this.resultProducts
                }
            }
        },
        updateProducts: function (updateProducts) {
            this.products = updateProducts.products;
            this.getPageCount = Number(updateProducts.last_page);
            this.isSearchedProduct = false;
            this.currentPage = 1;
        },
        fetchProductSettings() {
            // 商品設定を取得
            let url = '/api/productSettings';
            this.axios.get(url)
                .then((res) => {
                    // ランキング除外設定を抽出
                    var data = { ...res.data };
                    var ids = [];
                    for (var setting of data.product_settings) {
                        if (setting.is_ranking_excluded === 1) {
                            ids.push(setting.product_id);
                        }
                    }
                    this.excludedProducts = [...ids];
                }).catch(() => {
                });
        },
    },
    computed: {
        closeStatus: function () {
            if (!this.$store.state.loading && !this.$store.state.added) {
                return true
            } else {
                return false
            }
        }
    }
}
</script>

<style scoped lang="sass">
.containerInner
    overflow: hidden
    .productListHeader
        color: $grayColor
        display: flex
        font-size: 1.4rem
        margin: 20px 140px 0 140px
        padding: 10px 0
        .headerLeftMenu
            flex: 1 1 100%
            span
                display: inline-block
                vertical-align: middle
                .searchInputText
                    margin-left: 20px
                    padding: 10px
                    width: 360px
                    &:focus
                        outline: 2px solid $mainColor
                .searchBtn
                    border: 1px solid $mainColor
                    margin: 0 20px 0 10px
                    padding: 12px
                    width: 60px
                    &:hover
                        border: 1px solid $mainColor
                #unregistered
                    display: none
                .unregisteredCheckBox
                    line-height: 18px
                    padding-left: 25px
                    position: relative
                    &::before
                        background: $whiteColor
                        border: 1px solid $grayColor
                        content: ''
                        cursor: pointer
                        display: block
                        height: 15px
                        position: absolute
                        width: 15px
                    &::after
                        border-bottom: 3px solid $mainColor
                        border-right: 3px solid $mainColor
                        content: ''
                        cursor: pointer
                        display: block
                        height: 9px
                        left: 5px
                        margin-top: -8px
                        opacity: 0
                        position: absolute
                        top: 50%
                        transform: rotate(45deg)
                        width: 5px
                #unregistered:checked + .unregisteredCheckBox::after
                    opacity: 1
        .headerRightMenu
            flex: 1 0 auto
            span
                display: inline-block
                text-align: left
                vertical-align: middle
                .newProductBtn, .adsetUpdateBtn
                    border: 1px solid $mainColor
                    margin-left: 20px
                    padding: 12px
                    width: 120px
                    &:hover
                        border: 1px solid $mainColor
                    span
                        font-size: 0.3rem
                .addBtn
                    border: 1px solid $mainColor
                    margin-left: 20px
                    padding: 12px
                    width: 170px
                    &:hover
                        border: 1px solid $mainColor
                    span
                        font-size: 0.3rem
    .productList
        background: $whiteColor
        font-size: 1.2rem
        height: 75%
        margin: 10px 140px 0 140px
        overflow-y: scroll
        .productInfo
            border-bottom: 3px solid #f8f8ff
            color: $grayColor
            display: flex
            padding: 20px 0 20px 30px
            &:last-child
                border-width: 0px
            .productInfoLeft
                width: 90%
            p
                margin-bottom: 10px
                &:last-child
                    margin-bottom: 0px
            .productName
                font-weight: 700
            .productNo
            .productAdset
            .registeredAds
                display: inline-block
                vertical-align: top
                tr
                    &:first-child
                        .registeredByAdMediaAd
                            padding-top: 0px
                    .registeredByAdMediaAd
                        border-bottom: 1px solid rgba(2, 173, 144, 0.25)
                        padding: 4px 0 3px 5px
            .productExcluded
                text-align: right
                font-size: 1.4rem
                font-weight: 700
        .productInfoRight
            display: flex
            flex-direction: column
            margin-right: 30px
            .editBtn
                border: 1px solid $mainColor
                margin-left: 20px
                padding: 8px
                width: 120px
                height: 30px
                &:hover
                    border: 1px solid $mainColor
    .productListFooter
        margin: 15px 140px 0 140px
        position: relative
        .pageDisp
            font-size: 1.3rem
            line-height: 42px
            right: 15px
            position: absolute
            top: 50%
    .loadingWindow
        background: rgba(255, 255, 255, 0.8)
        height: 100%
        left: 0
        position: absolute
        top: 0px
        width: 100vw
        z-index: 1000
        .loadingWindowInner
            left: 50%
            position: absolute
            text-align: center
            top: 50%
            transform: translate(-50%, -50%)
            z-index: 1000
            p
                font-size: 2.5rem
                margin-bottom: 40px
@include sp()
    .containerInner
        .productListHeader
            display: block
            margin: 5px 0 0 10px
            .headerLeftMenu
                span
                    .searchInputText
                        width: 150px
            .headerRightMenu
                margin-top: 10px
        .productList
            margin: 10px 0 0
</style>
